export default __webpack_public_path__ + "static/media/dark_pattern_bg.e1ef4615.png";